import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';

export default function HotArticles() {
  const featured = articles.filter((a) => a.featured).slice(0, 4);
  const latest = articles.filter((a) => !a.featured).slice(0, 6);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            热门爆料
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
          {featured.slice(0, 1).map((article) => (
            <div key={article.id} className="md:col-span-2 lg:col-span-3">
              <ArticleCard {...article} featured />
            </div>
          ))}
          {featured.slice(1).map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>

        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            最新发布
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {latest.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>
      </div>
    </section>
  );
}